module.exports = __webpack_public_path__ + "img/number-4.72bed0d1.png";